import { Button } from "@stackje/shared-components/ui/button";
import { GlobeIcon, ShareIcon } from "lucide-react";
import { useNavigate } from "@tanstack/react-router";
import { InstallPwaBanner } from "./InstallPwaBanner";

export function PublishedPage({ siteUrl }: { siteUrl: string }) {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50 flex flex-col pb-safe pt-safe pl-safe pr-safe">
      <InstallPwaBanner />

      {/* Published Content */}
      <div className="flex-1 flex items-center justify-center py-12">
        <div className="max-w-md w-full mx-auto text-center space-y-8 px-8">
          {/* Success Animation */}
          <div className="success-animation mb-8">
            <img
              src="/assets/animations/rocket-launch.gif"
              alt="Rocket Launch"
              className="mx-auto"
            />
          </div>

          <h1 className="text-3xl font-bold">Changes Published!</h1>
          <p className="text-gray-600">
            Your changes are now live and ready to be shared with the world.
          </p>

          {/* Action Buttons */}
          <div className="space-y-4 pt-8">
            <Button
              className="w-full"
              onClick={() => {
                navigator
                  .share?.({
                    title: "Check out my page!",
                    url: siteUrl,
                  })
                  .catch(() => {
                    // Fallback to copying to clipboard
                    navigator.clipboard.writeText(siteUrl);
                  });
              }}
            >
              <ShareIcon className="mr-2 h-4 w-4" />
              Share Your Page
            </Button>
            <Button
              className="w-full"
              variant="outline"
              onClick={() => window.open(siteUrl, "_blank")}
            >
              <GlobeIcon className="mr-2 h-4 w-4" />
              View Your Page
            </Button>

            <Button
              className="w-full underline text-gray-600"
              variant="ghost"
              onClick={() => navigate({ to: "/" })}
            >
              Back to Dashboard
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
